var ValuesClass = (function () {
    function ValuesClass() {
    }
    return ValuesClass;
}());
//# sourceMappingURL=ValuesClass.js.map